export default __webpack_public_path__ + "static/freeTotes-f549ac0d0dc54f09e7e5941f10e76d63.svg";